<template>
  <v-row>
    <div
      v-if="description"
      v-html="description"
      class="description"
    >
    </div>
    <ValidationProvider :name="field.name | slugify" slim :rules="rules" v-slot="{ errors }">
      <v-select :items="field.metadata.choices"
                item-text="title"
                :error-messages="errors[0]"
                :class="{filled: value.length > 0}"
                :multiple="multiple"
                v-model="value"></v-select>
    </ValidationProvider>
  </v-row>
</template>


<script>
  import _ from 'lodash'

  export default {
    name: 'SelectField',
    props: ['field', 'multiple'],
    data() {
      return {
        value: this.multiple ? [] : this.field.metadata.choices[0],
      }
    },
    computed: {
      description() {
        const fieldDescription =
          _.get(this.field, 'metadata.description', '') || _.get(this.field, 'description', '')

        if (!_.isEmpty(fieldDescription)) {
          return fieldDescription
        }

        return ''
      },
      rules() {
        return this.field.required ? 'requiredSelect' : '';
      }
    },
    watch: {
      value(newVal) {
        this.$emit("select", {
          key: this.field.key,
          value: newVal,
          identity: this.field.identity ? this.field.identity : false
        });
      },
    }
  }
</script>

<style>

</style>
